<template>
    <ActivityDetailsCard
        activityType="Premium Research"
        :title="interview.title"
        :entity="item.entity"
        class="loading-container"
    >
        <template #sub-header>
            <div class="cell">
                <h5>Published</h5>
                {{ publishedDate }}
            </div>
            <div class="cell">
                <h5>Source Bias</h5>
                {{ interview.sourceBias }}
            </div>
            <div class="cell">
                <h5>Remuneration</h5>
                {{ interview.remuneration }}
            </div>
            <div class="cell">
                <h5>Overlap</h5>
                <EditorText :value="interview.overlapRange" />
            </div>
        </template>

        <section>
            <div class="actions">
                <router-link
                    class="primary button"
                    :to="{ name: 'executive-page', params: { id: item.entity.id }, query: { tab: 'Premium Research' } }"
                >
                    View Report
                </router-link>
                <button class="primary" @click="showingTranscript = true">Read Transcript</button>
            </div>
            <dl>
                <dt>Summary</dt>
                <dd><EditorText :value="interview.summary" /></dd>

                <dt>Relevance</dt>
                <dd><EditorText :value="interview.relevance" /></dd>

                <dt>Key Quotes</dt>
                <dd><EditorText :value="interview.keyQuote1" /></dd>
                <dd><EditorText :value="interview.keyQuote2" /></dd>
                <dd><EditorText :value="interview.keyQuote3" /></dd>
            </dl>

            <ActivityStockPriceLine :item="item" />
        </section>

        <loading :active="updating" :is-full-page="false" />

        <InterviewModal
            :interview="interview"
            tab="Transcript"
            @dismiss="showingTranscript = false"
            v-if="showingTranscript"
        />
    </ActivityDetailsCard>
</template>

<script setup>
import { InterviewService } from '@/services/interviewService'

import ActivityDetailsCard from '../ActivityDetailsCard.vue'
import ActivityStockPriceLine from '../ActivityStockPriceLine.vue'
import EditorText from '@/components/inputs/RichTextEditor/EditorText.vue'
import InterviewModal from '@/components/executives/Research/InterviewModal.vue'
import { computed, inject, ref } from 'vue'
import { asyncComputed } from '@/utils/asyncComputed'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const showingTranscript = ref(false)
const entityId = computed(() => props.item.details?.entityId)
const interview = asyncComputed(() => InterviewService.get(entityId.value), {
    keyQuote1: '',
    keyQuote2: '',
    keyQuote3: '',
    sourceBias: '',
    remuneration: '',
    summary: '',
    relevance: '',
    overlapRange: '',
    title: '',
})

const updating = computed(() => interview.updating)
const publishedDate = computed(() => new Date(interview.value.publishedDate).toLocaleDateString())
</script>

<style scoped>
.actions {
    display: flex;
    flex-direction: row;
    gap: 16px;
}
.actions > * {
    flex: 1 1 50%;
}

dl {
    display: flex;
    flex-direction: column;
    grid-template-columns: auto minmax(0, 1fr);
}

dt {
    grid-column: 1;
    font-weight: 700;
    margin-right: 16px;
}

dd {
    grid-column: 2;
}

dt,
dd,
p {
    font-size: 12pt;
    line-height: 1.4;
}

dt,
dd,
p:not(:last-child) {
    margin-bottom: 16px;
}

section {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
</style>
